// extracted by mini-css-extract-plugin
export default {"bandage":"DashboardHeader_bandage__ccGuA"};